import { Builder, builder } from '@builder.io/react';
import { carouselConfig } from '@builder.io/widgets/dist/lib/components/Carousel.config';
import loadable from '@loadable/component';

import borderRadius from '../builder-io/storyblocks-design-system/design-tokens/borders';
import colors from '../builder-io/storyblocks-design-system/design-tokens/colors';
import boxShadow from '../builder-io/storyblocks-design-system/design-tokens/shadows';
import spacing from '../builder-io/storyblocks-design-system/design-tokens/spacings';
import './components/blocks/Alert.builder';
import './components/blocks/AnimatedCounter.builder';
import './components/blocks/Articles.builder';
import './components/blocks/AssetTypeCard.builder';
import './components/blocks/AssetsCounter.builder';
import './components/blocks/AudioCardList.builder';
import './components/blocks/BrowseCategories.builder';
import './components/blocks/Button.builder';
import './components/blocks/ButtonV1.builder';
import './components/blocks/CardSection.builder';
import './components/blocks/CategoryPills.builder';
import './components/blocks/ContentCarousel.builder';
import './components/blocks/DualMediaAndText.builder';
import './components/blocks/FAQ.builder';
import './components/blocks/FAQV1.builder';
import './components/blocks/FeaturedArtists.builder';
import './components/blocks/FeaturesCards.builder';
import './components/blocks/FooterHook.builder';
import './components/blocks/FooterHookLegacy.builder';
import './components/blocks/Genres.builder';
import './components/blocks/HomepageProminentSearch.builder';
import './components/blocks/HomepageTypewriter.builder';
import './components/blocks/Hubspot.builder';
import './components/blocks/ImageAndText.builder';
import './components/blocks/ImageCards.builder';
import './components/blocks/ImageContentGrid.builder';
import './components/blocks/Logos.builder';
import './components/blocks/MediaAndText.builder';
import './components/blocks/MediaHero.builder';
import './components/blocks/MediaTypeChip.builder';
import './components/blocks/Moods.builder';
import './components/blocks/NewTag.builder';
import './components/blocks/Pills.builder';
import './components/blocks/Pricing.builder';
import './components/blocks/ProminentSearch/ProminentSearch.builder';
import './components/blocks/RichText.builder';
import './components/blocks/SearchBar.builder';
import './components/blocks/SearchHero.builder';
import './components/blocks/SeoText.builder';
import './components/blocks/SeoTextAndImage.builder';
import './components/blocks/SfxTag.builder';
import './components/blocks/SiteMap.builder';
import './components/blocks/SiteMapCategory.builder';
import './components/blocks/SocialProof.builder';
import './components/blocks/Stack.builder';
import './components/blocks/StaffPickTag.builder';
import './components/blocks/StoryblocksLogo.builder';
import './components/blocks/Tabs.builder';
import './components/blocks/Testimonials.builder';
import './components/blocks/TestimonialsV2/TestimonialsV2.builder';
import './components/blocks/Text.builder';
import './components/blocks/TextHero.builder';
import './components/blocks/ThankYou.builder';
import './components/blocks/Tooltip.builder';
import './components/blocks/ValueProps.builder';
import './components/blocks/VideoArticles.builder';
import './components/blocks/VideoCarousel.builder';
import './components/blocks/VideoContentGrid.builder';
import './components/blocks/legacy/Articles.builder';
import './components/blocks/legacy/BenefitsV1.builder';
import './components/blocks/legacy/DualMediaAndText.builder';
import './components/blocks/legacy/ImageCards.builder';
import './components/blocks/legacy/ImageHero.builder';
import './components/blocks/legacy/MediaAndText.builder';
import './components/blocks/legacy/Pills.builder';
import './components/blocks/legacy/Pricing.builder';
import './components/blocks/legacy/VideoContentGrid.builder';
import './components/blocks/legacy/VideoHero.builder';
import './components/blocks/vimeo/Vimeo.builder';
import './components/blocks/wistia/Wistia.builder';
import './components/blocks/youtube/Youtube.builder';
import './components/elements/FormattedDate.builder';

/**
 * Imports all custom blocks from builder-io/components
 */

builder.init(__BUILDER_PUBLIC_KEY__);

/*
 * Import Custom Builder Widgets
 */
Builder.registerComponent(
  loadable(() =>
    import('@builder.io/widgets/dist/lib/components/Carousel').then(
      (mod) => mod.CarouselComponent
    )
  ),
  carouselConfig
);

Builder.register('insertMenu', {
  name: 'Design System - Atoms',
  items: [
    { name: 'Alert' },
    { name: 'Animated Counter' },
    { name: 'Button' },
    { name: 'Button SB' },
    { name: 'Checkbox' },
    { name: 'Logos Component' },
    { name: 'New tag' },
    { name: 'Sfx tag' },
    { name: 'Staff pick tag' },
    { name: 'Storyblocks logo' },
    { name: 'Tab' },
    { name: 'Text SB' },
    { name: 'Tooltip' },
  ],
});

Builder.register('insertMenu', {
  name: 'Design System - Molecules',
  items: [
    { name: 'Asset Type Card' },
    { name: 'Audio Card List' },
    { name: 'Benefits (v1)' },
    { name: 'Browse Categories' },
    { name: 'Category Pills' },
    { name: 'Faq SB' },
    { name: 'Features Cards' },
    { name: 'Footer Hook SB' },
    { name: 'Hubspot' },
    { name: 'Image Content Grid' },
    { name: 'Image Hero' },
    { name: 'v2:Hubspot' },
    { name: 'v3:Hubspot' },
    { name: 'Media Type Chip' },
    { name: 'Plan Card' },
    { name: 'Prominent Search' },
    { name: 'RichText SB' },
    { name: 'Social Proof' },
    { name: 'Stack' },
    { name: 'Tabs' },
    { name: 'Testimonials V2' },
    { name: 'Value Props' },
    { name: 'Video Card' },
    { name: 'Video Articles' },
    { name: 'Video Carousel' },
    { name: 'Video Content Grid' },
  ],
});

Builder.register('insertMenu', {
  name: 'Archive - Old/Outdated Components',
  items: [
    { name: 'Articles' },
    { name: 'Articles (Legacy)' },
    { name: 'Assets Counter' },
    { name: 'Benefits (v1)' },
    { name: 'Card Section' },
    { name: 'Content Carousel' },
    { name: 'FAQ' },
    { name: 'Featured Artists' },
    { name: 'Footer Hook' },
    { name: 'Formatted Date' },
    { name: 'Genres' },
    { name: 'Homepage Prominent Search' },
    { name: 'Homepage Typewriter' },
    { name: 'Image And Text' },
    { name: 'Logos' },
    { name: 'Media And Text (Dual)' },
    { name: 'Media And Text (Dual) Legacy' },
    { name: 'Media And Text' },
    { name: 'Media And Text (Legacy)' },
    { name: 'Image Cards' },
    { name: 'Image Cards (Legacy)' },
    { name: 'Image Hero' },
    { name: 'Media Hero' },
    { name: 'Moods' },
    { name: 'Pills' },
    { name: 'Pills (Legacy)' },
    { name: 'Pricing' },
    { name: 'Pricing (Legacy)' },
    { name: 'Search Bar' },
    { name: 'Search Hero' },
    { name: 'SEO Text And Image' },
    { name: 'SEO Text' },
    { name: 'Site Map Category' },
    { name: 'Site Map' },
    { name: 'Testimonials' },
    { name: 'Text Hero' },
    { name: 'Thank You' },
    { name: 'Video Content Grid (Legacy)' },
    { name: 'Video Hero (Legacy)' },
    { name: 'Vimeo' },
    { name: 'Wistia' },
    { name: 'Youtube' },
    { name: 'Homepage Typewriter' },
    { name: 'Homepage Prominent Search' },
    { name: 'Search Hero' },
    { name: 'Content Carousel' },
    { name: 'Formatted Date' },
    { name: 'Search Bar' },
  ],
});

Builder.register('insertMenu', {
  name: 'Storywind',
  items: [
    { name: 'Alert' },
    { name: 'Button' },
    { name: 'New tag' },
    { name: 'Sfx tag' },
    { name: 'Stack' },
    { name: 'Staff pick tag' },
    { name: 'Storyblocks logo' },
  ],
});

// Design tokens
Builder.register('editor.settings', {
  allowOverridingTokens: true,
  styleStrictMode: false,
  designTokens: {
    fontFamily: [
      {
        name: 'polysans-neutral',
        value: 'polysans_neutral',
      },
      {
        name: 'polysans-median',
        value: 'polysans_median',
      },
      {
        name: 'polysans-median-italic',
        value: 'polysans_median_italic',
      },
    ],
    colors,
    borderRadius,
    spacing,
    boxShadow,
  },
});
